package com.essntl.features.supplier.ui

import androidx.compose.foundation.layout.*
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.button.secondary.EsLargeSecondaryButton
import com.essntl.uikit.components.dialog.EsDialog
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ContactSupplierPopup(
    isOpen: Boolean,
    onDismissRequest: () -> Unit,
    openMessagePopup: () -> Unit,
) {
    if (isOpen)
        EsDialog(
            title = "Contact Supplier",
            onDismissRequest = onDismissRequest,
        ) {
            Column(
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.CenterHorizontally,
                modifier = Modifier
                    .padding(2.5.spacing),
            ) {
                Text(
                    "The service has been modified after the purchase order was sent.\n\n" +
                        "Would you like to contact the supplier with the new service details",
                    style = MaterialTheme.esTypography.p2Regular14.copy(color = MaterialTheme.esColorScheme.primary),
                    modifier = Modifier.fillMaxWidth(),
                )

                Spacer(modifier = Modifier.height(8.spacing))

                Row(
                    horizontalArrangement = Arrangement.SpaceBetween,
                    modifier = Modifier.fillMaxWidth(),
                ) {
                    EsLargePrimaryButton(
                        text = "Confirm",
                        onClick = openMessagePopup,
                        modifier = Modifier.weight(1F),
                    )
                    Spacer(modifier = Modifier.width(2.5.spacing))
                    EsLargeSecondaryButton(
                        text = "Cancel",
                        onClick = onDismissRequest,
                        modifier = Modifier.weight(1F),
                    )
                }
            }
        }
}